import { createFileRoute, useParams } from "@tanstack/react-router";
import { createTicketNotesListQueryOptions } from "@/features/notes/adapters/ticket-notes-adapter";
import { TicketNotesWorkspace } from "@/features/notes/components/ticket-notes-workspace";
import { NOTES_PAGE_SIZE } from "@/features/notes/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/notes",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createTicketNotesListQueryOptions({
				ticketId: params.ticketId,
				organizationId: params.orgId,
				start: 1,
				count: NOTES_PAGE_SIZE,
			}),
		),
	component: TicketWorkspaceNotesTab,
});

/**
 * Job workspace Notes tab — thin route adapter.
 */
function TicketWorkspaceNotesTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/notes",
	});

	return (
		<TicketNotesWorkspace orgId={params.orgId} ticketId={params.ticketId} />
	);
}
